export default __webpack_public_path__ + "static/media/ss-gizmo.95c216ad.ttf";